import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skinConcernFragment = `
    on ${QueryType.product} {
        skin {
            concern {
                key
                value
            }
        }
    }
`;

export const skinConcernFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: skinConcernFragment
    };
};
